import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePageSeo } from "../../shared/seo";

const SuccessPage = () => {
  usePageSeo("orderSuccess");
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    setTimeout(() => setShowConfetti(false), 6000);
  }, []);

  return (
    <div style={styles.container} className="success-page">
      {showConfetti && <Confetti />}

      <div style={styles.content} className="success-page__content">
        <div style={styles.checkmark} className="success-page__check">
          <svg
            style={styles.checkmarkSvg}
            className="success-page__check-svg"
            viewBox="0 0 52 52"
          >
            <circle
              style={styles.checkmarkCircle}
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              style={styles.checkmarkCheck}
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <h1 style={styles.title} className="success-page__title">
          Order Placed Successfully!
        </h1>
        <p style={styles.subtitle} className="success-page__subtitle">
          Your order is confirmed and will be delivered soon
        </p>

        {/* <div style={styles.infoGrid}>
          <div style={styles.infoCard}>
            <i className="ri-shopping-bag-3-line" style={styles.icon}></i>
            <span style={styles.label}>Order ID</span>
            <span style={styles.value}>#{Math.random().toString(36).substr(2, 9).toUpperCase()}</span>
          </div>
          <div style={styles.infoCard}>
            <i className="ri-truck-line" style={styles.icon}></i>
            <span style={styles.label}>Delivery</span>
            <span style={styles.value}>3-5 Days</span>
          </div>
          <div style={styles.infoCard}>
            <i className="ri-mail-check-line" style={styles.icon}></i>
            <span style={styles.label}>Email Sent</span>
            <span style={styles.value}>Confirmed</span>
          </div>
        </div> */}

        <div style={styles.actions} className="success-page__actions">
          <Link
            to={"/my-orders"}
            style={styles.primaryBtn}
            className="success-page__primary"
          >
            <i className="ri-file-list-3-line"></i>
            Go to Orders
          </Link>
          <Link
            to={"/"}
            style={styles.secondaryBtn}
            className="success-page__secondary"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

const Confetti = () => {
  const pieces = Array.from({ length: 200 });
  return (
    <div style={styles.confettiContainer}>
      {pieces.map((_, i) => (
        <div
          key={i}
          style={{
            ...styles.confettiPiece,
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 4}s`,
            animationDuration: `${2 + Math.random() * 2}s`,
            width: `${5 + Math.random() * 10}px`,
            height: `${5 + Math.random() * 10}px`,
            backgroundColor: [
              "#2e8b57",
              "#ffd700",
              "#ff6b6b",
              "#4ecdc4",
              "#a78bfa",
              "#fb923c",
            ][Math.floor(Math.random() * 6)],
          }}
        />
      ))}
    </div>
  );
};

const styles = {
  container: {
    minHeight: "65vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    padding: "40px 20px",
    position: "relative",
    overflow: "hidden",
  },
  confettiContainer: {
    position: "fixed",
    inset: 0,
    pointerEvents: "none",
    zIndex: 10,
  },
  confettiPiece: {
    position: "absolute",
    top: "-20px",
    opacity: 0,
    animation: "confettiFall 3s ease-out forwards",
    borderRadius: "2px",
  },
  content: {
    textAlign: "center",
    position: "relative",
    zIndex: 5,
    maxWidth: "700px",
    width: "100%",
    animation: "fadeInUp 0.8s ease-out",
  },
  checkmark: {
    width: "120px",
    height: "120px",
    margin: "0 auto 32px",
    background: "#e8f5ee",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 40px rgba(46, 139, 87, 0.2)",
    animation: "scaleIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
  },
  checkmarkSvg: {
    width: "70px",
    height: "70px",
  },
  checkmarkCircle: {
    strokeDasharray: 166,
    strokeDashoffset: 166,
    strokeWidth: 3,
    stroke: "#2e8b57",
    animation: "stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards",
  },
  checkmarkCheck: {
    strokeDasharray: 48,
    strokeDashoffset: 48,
    stroke: "#2e8b57",
    strokeWidth: 4,
    strokeLinecap: "round",
    animation: "stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.9s forwards",
  },
  title: {
    fontSize: "48px",
    fontWeight: "800",
    color: "#111827",
    margin: "0 0 16px",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "20px",
    color: "#6b7280",
    margin: "0 0 48px",
    fontWeight: "400",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "20px",
    marginBottom: "48px",
  },
  infoCard: {
    background: "#f9fafb",
    border: "2px solid #e5e7eb",
    borderRadius: "20px",
    padding: "28px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    animation: "slideUp 0.6s ease-out backwards",
    transition: "all 0.3s ease",
  },
  icon: {
    fontSize: "36px",
    color: "#2e8b57",
    marginBottom: "4px",
  },
  label: {
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  value: {
    fontSize: "18px",
    color: "#111827",
    fontWeight: "700",
  },
  actions: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  primaryBtn: {
    background: "linear-gradient(135deg, #2e8b57 0%, #1e6b3f 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "50px",
    padding: "18px 40px",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    boxShadow: "0 8px 24px rgba(46, 139, 87, 0.3)",
    transition: "all 0.3s ease",
  },
  secondaryBtn: {
    background: "#ffffff",
    color: "#2e8b57",
    border: "2px solid #2e8b57",
    borderRadius: "50px",
    padding: "18px 40px",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes confettiFall {
    0% { opacity: 0; transform: translateY(0) rotate(0deg); }
    10% { opacity: 1; }
    100% { opacity: 0; transform: translateY(100vh) rotate(720deg); }
  }
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(40px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes scaleIn {
    from { transform: scale(0) rotate(-180deg); }
    to { transform: scale(1) rotate(0deg); }
  }
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes stroke {
    to { stroke-dashoffset: 0; }
  }
  button:hover {
    transform: translateY(-3px) scale(1.05);
  }
  button:active {
    transform: translateY(-1px) scale(1.02);
  }
  div[style*="infoCard"]:hover {
    transform: translateY(-5px);
    border-color: #2e8b57;
    box-shadow: 0 12px 40px rgba(46, 139, 87, 0.15);
  }
  @media (max-width: 768px) {
    .success-page {
      min-height: 70vh !important;
      padding: 32px 16px !important;
    }

    .success-page__check {
      width: 84px !important;
      height: 84px !important;
      margin: 0 auto 22px !important;
    }

    .success-page__check-svg {
      width: 48px !important;
      height: 48px !important;
    }

    .success-page__title {
      font-size: 26px !important;
      letter-spacing: -0.3px !important;
      margin-bottom: 10px !important;
    }

    .success-page__subtitle {
      font-size: 14px !important;
      max-width: 280px !important;
      margin: 0 auto 28px !important;
    }

    .success-page__actions {
      flex-direction: column !important;
      gap: 12px !important;
      width: 100% !important;
    }

    .success-page__primary,
    .success-page__secondary {
      width: 100% !important;
      justify-content: center !important;
      padding: 14px 20px !important;
      font-size: 15px !important;
    }
  }
`;
document.head.appendChild(styleSheet);

export default SuccessPage;
